import { ElementType, SyntheticEvent } from 'react';
import moment from 'moment';

import i18n from 'i18n';
import { Clock } from 'types';

export { default as GroupLoader } from './GroupLoader';
export { default as ImageLoader } from './ImageLoader';

export const clearEvent = (event?: SyntheticEvent) => {
  if (event) {
    event.stopPropagation();

    if (event.cancelable) {
      event.preventDefault();
    }
  }
};

export const classes = (...args: (string | undefined | null | false | 0)[]) => {
  const arr: string[] = [];
  args.forEach(arg => (arg ? arr.push(arg) : null));
  return arr.join(' ');
};

export const call = (func?: (...args: any[]) => any, ...args: any[]) => {
  if (typeof func === 'function') {
    return func(...args);
  }
};

export const splitValueUnit = (value: number | string, defaultUnit = 'px') => {
  switch (typeof value) {
    case 'number':
      return { value, unit: defaultUnit, join: `${value}${defaultUnit}` };

    case 'string': {
      const unit = value.replace(/[0-9.]/g, '') || defaultUnit;
      value = Number(value.replace(/[^0-9.]/g, ''));

      return { value, unit, join: `${value}${unit}` };
    }

    default:
      break;
  }

  throw new Error(`invalid input: ${value}`);
};

export const renderComponent = (Component?: ElementType, props?: object) =>
  Component ? <Component {...props} /> : null;

export const renderMessage = (key: string) => {
  const text = i18n.t(key, { returnObjects: true });

  if (Array.isArray(text)) {
    return text.map((el, index) => <span key={`${key}.${index}`}>{el}</span>);
  }

  return <span>{text}</span>;
};

export const utcOffset = () => {
  const minutes = moment().utcOffset();
  const abs = Math.abs(minutes);

  const sig = minutes < 0 ? '-' : '';
  const hh = String(Math.ceil(abs / 60)).padStart(2, '0');
  const mm = String(abs % 60).padStart(2, '0');

  return `utcOffset=${sig}${hh}${mm}`;
};

export const parseClock = (clock?: Clock) =>
  clock
    ? `${String(clock.minutes).padStart(2, '0')}:${String(clock.seconds).padStart(
        2,
        '0'
      )}`
    : '';

export const parsePeriod = (period?: string) =>
  period && period !== 'undefined' ? period : '';

export function gtag(...arg: any[]) {
  try {
    if (
      window.location.hostname !== 'localhost' &&
      window.location.hostname !== '127.0.0.1' &&
      window.location.hostname !== ''
    ) {
      return (window as { [key: string]: any })['gtag'](...arg);
    }
  } catch (error) {}
}
